import { TrackingBctAdapter } from './adapters'
import { logger } from '@otto-ec/eprivacy-shared'
import { TrackingLabels, TrackingService } from './core'
import {
  getConsentTtl,
  hasConsentBeenGiven,
} from '@otto-ec/eprivacy-onetrust-sdk'
import {
  createMeasureServiceFor,
  MeasureType,
} from '@otto-ec/eprivacy-measures'
import { SERVICE, TEAM } from '@otto-ec/eprivacy-shared'

const trackingBctAdapter = new TrackingBctAdapter<TrackingLabels>(logger)
export const trackingService = new TrackingService(
  trackingBctAdapter,
  hasConsentBeenGiven,
  getConsentTtl
)

export const initMeasureService = createMeasureServiceFor(
  MeasureType.Init,
  TEAM,
  SERVICE
)
